import * as form from '../form';

export const legalTechnologyUnlawful = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Date: form.datecontrol(xitem.Date),
        Incident: form.textarea(xitem.Incident),
        Location: form.location(xitem.Location),
        Action: form.textarea(xitem.Action),
        // PVQ Form elements
        UnlawfulAccessLocations: form.checkboxgroup(xitem.UnlawfulAccessLocations),
        SystemName: form.text(xitem.SystemName),
        SystemOwner: form.text(xitem.SystemOwner),
        SystemOwnerNotApplicable: form.notapplicable(xitem.SystemOwnerNotApplicable),
        HadSuccess: form.branch(xitem.HadSuccess),
        Frequency: form.radio(xitem.Frequency),
        FrequencyOtherExplanation: form.textarea(xitem.FrequencyOtherExplanation), // P
        IsShared: form.branch(xitem.IsShared),
        SharedName: form.name(xitem.SharedName),
        ActionDetails: form.textarea(xitem.ActionDetails),
        ActionOtherDetails: form.textarea(xitem.ActionOtherDetails),
        UnauthorizedActions: form.checkboxgroup(xitem.UnauthorizedActions),
        Reason: form.textarea(xitem.Reason),
        // End PVQ Only elements
      },
    };
  });
  return {
    HasUnlawful: form.branch(data.HasUnlawful),
    List: form.collection(items, (data.List || {}).branch),
  };
};
